let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g2azy")).then(() => parcelRequire('3y2l5'));